import React, { memo } from "react";
import { useSelector } from "react-redux";

import { hasAdminAccessOrAnyPermission, hasAdminAccessOrPermissions } from "../helpers";

export const Protected = memo(
  ({ permissions = [], match = "all", children, noAccess = null }) => {
    const user = useSelector((state) => state.auth.user);

    const hasAccess =
      !user || Object.keys(user).length === 0
        ? false
        : match === "any"
          ? hasAdminAccessOrAnyPermission(user, permissions)
          : hasAdminAccessOrPermissions(user, permissions);

    if (!hasAccess) {
      return noAccess;
    }

    return <>{children}</>;
  },
  arePropsEqual
);

Protected.displayName = "Protected";

// Helpers
function arePropsEqual(prev, next) {
  const otherPropsEqual =
    Object.is(prev.noAccess, next.noAccess) &&
    Object.is(prev.children, next.children) &&
    prev.match === next.match;

  if (!otherPropsEqual) return false;
  return arePermissionsEqual(prev.permissions, next.permissions);
}

function arePermissionsEqual(prevPermissions, nextPermissions) {
  if (!prevPermissions && !nextPermissions) return true;
  if (!prevPermissions || !nextPermissions) return false;
  if (prevPermissions.length !== nextPermissions.length) return false;

  // Both empty arrays - consider equal
  if (prevPermissions.length === 0) return true;

  // Check if all permissions match in both directions
  return (
    prevPermissions.every((permission) =>
      nextPermissions.includes(permission)
    ) &&
    nextPermissions.every((permission) => prevPermissions.includes(permission))
  );
}
